import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getAmendHistoryData = createAsyncThunk('/prosafe/po/get-amendment-diff',
    async ({ payload }) => {
        try {
            const myurl = `${V_URL}/prosafe/po/get-amendment-diff`;
            const response = await axios({
                method: 'post',
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN'),
                },
            });
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            return error
        }
    })

const getAmendHistoryDataSlice = createSlice({
    name: "getAmendHistoryData",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetAmendHistoryData: (state) => {
            state.user = null;
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAmendHistoryData.pending, (state) => {
                state.loading = true;
                state.user = null;
                state.error = null;
            })
            .addCase(getAmendHistoryData.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getAmendHistoryData.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export const { resetAmendHistoryData } = getAmendHistoryDataSlice.actions;
export default getAmendHistoryDataSlice.reducer;